import { Route, Routes } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import LoginPage from "./pages/login";
import SpySearch from "./pages/SpySearch";
import Dashboard from "./pages/Dashboard";
import AmozonFlips from "./pages/AmazonFlips";
import Home from "./pages/Home";
import Toast from "./components/Toast";
import ErrorPage from "./components/ErrorPage";
import "react-toastify/dist/ReactToastify.css";
import { useContext, useEffect, useState } from "react";
import { ThemeContext } from "./context/themeContext";
import NetworkMaintenanceOverlay from "./components/NetworkMaintenanceOverlay";
import Preiswecker from "./pages/Preiswecker";
import Guide from "./pages/Guide";
import AuthGuard from "./AuthGuard";
import { useSelector } from "react-redux";
import "react-loading-skeleton/dist/skeleton.css";
import WholesaleScanner from "./pages/WholesaleScanner";
import SupplierScanner from "./pages/SupplierScanner";
import WholesaleWizard from './pages/WholesaleWizard';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import Onboarding from "./pages/Onboarding";
import Settings from "./pages/Settings";
import ChurnFlow from "./pages/ChurnFlow";
import DiscordIntegrationOAuth from "./pages/DiscordIntegrationOAuth";
import AmazonIntegrationOAuth from "./pages/AmazonIntegrationOAuth";

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60, // 1 minute
      cacheTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

const App = () => {
  const { themeLoad } = useContext(ThemeContext);
  const authStatus = useSelector((state) => state.auth.status);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (authStatus === "authorized" || authStatus === "unauthorized") {
      setLoading(false);
    }
  }, [authStatus]);

  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <Routes>
          <Route path="/onboarding" element={<Onboarding />} />
          <Route path="/churn" element={<ChurnFlow />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="*" element={<ErrorPage />} />

          <Route element={<AuthGuard />}>
            <Route path="/" element={<Home />} />
            <Route path="/home" element={<Dashboard />} />
            <Route path="/spySearch" element={<SpySearch />} />
            <Route path="/a2aFlips" element={<AmozonFlips />} />
            <Route path="/preiswecker" element={<Preiswecker />} />
            <Route path="/guide" element={<Guide />} />
            <Route path="/wholesale" element={<WholesaleWizard />} />
            <Route path='/wholesale/supplier/:supplierPrefix' element={<SupplierScanner />} />
            <Route path='/wholesale/favorite/:favoriteId' element={<WholesaleScanner />} />
            <Route path='/wholesale/:listId' element={<WholesaleScanner />} />
            <Route path="/settings" element={<Settings />} />
            <Route
              path="/integration/discord/oauth"
              element={<DiscordIntegrationOAuth />}
            />
            <Route
              path="/integration/amazon/oauth"
              element={<AmazonIntegrationOAuth />}
            />
          </Route>
        </Routes>
        <Toast />
        <NetworkMaintenanceOverlay />
        {(themeLoad || loading) && (
          <div className={`spinner ${loading ? "bg-background" : ""}`}>
            <i className="animate-spin bx bx-loader-alt text-4xl text-primary "></i>
          </div>
        )}
      </AuthProvider>
    </QueryClientProvider>
  );
};

export default App;
